// 수정시 scss/variables.scss에도 동일하게 수정해야함.
export const BREAKPOINTS = {
	MOBILE: 700,
	TABLET: 1350
} as const;
